<template>
  <div class="mgb10">
    <el-input
      placeholder="全库检索 输入货号"
      v-model.trim="invSearchProductNo"
      class="input-with-select"
    >
      <el-button
        slot="append"
        icon="el-icon-search"
        @click="clickSearchProductNo"
      ></el-button>
    </el-input>
  </div>
</template>

<script>
export default {
  data() {
    return {
      invSearchProductNo: null,
    };
  },

  created() {},
  methods: {
    clickSearchProductNo() {
      const self = this;
      if (self.invSearchProductNo == null || self.invSearchProductNo === "") {
        self.$message({
          message: self.$t("prompt.fillInValidProductNo"),
          type: "warning",
        });
      } else {
        self.$router.push({
          name: "wmsInventorySearch",
          params: {
            productNo: self.invSearchProductNo,
          },
        });
      }
    },
  },
};
</script>